import {
    Box,
    Heading,
    Stack,
    ThemeFontSizeVariable,
    ThemeSpaceVariable,
} from "@caspeco/casper-ui-library";
import { useTranslation } from "react-i18next";
import SectionOfAvailableTimes from "components/selection-components/select-time/section-of-available-times";
import { useStepTracking } from "logger/use-step-tracking";
import { TrackingStepName } from "logger/user-tracking";
import { TimeSlot } from "types/time-slot";
import { AvailableTimesSection } from "types/available-times";

interface EditTimeViewProps {
    availableTimesSections: AvailableTimesSection[];
    selectedTimeSlot: TimeSlot;
    setTime: (time: TimeSlot) => void;
}

const EditTimeView = ({ availableTimesSections, selectedTimeSlot, setTime }: EditTimeViewProps) => {
    const { t } = useTranslation();

    useStepTracking({
        stepName: TrackingStepName.EditBookingTime,
    });

    return (
        <Stack spacing={ThemeSpaceVariable.Medium}>
            <Heading as="h3" fontSize={ThemeFontSizeVariable.XLarge}>
                {t("editBooking.chooseNewTime")}
            </Heading>
            <Box px={ThemeSpaceVariable.None} className="available-times">
                {availableTimesSections.map((section) => (
                    <SectionOfAvailableTimes
                        key={`section${section.id}`}
                        availableTimesSection={section}
                        selectedTime={selectedTimeSlot}
                        onTimeClickOverride={setTime}
                        isEditBookingMode
                    />
                ))}
            </Box>
        </Stack>
    );
};

export default EditTimeView;
